<tool-drawer-container (openFormDialog)="openDialog()">
  <transfer-enrollment-trends-form
    class="form-slot"
  ></transfer-enrollment-trends-form>

  <tool-header
    class="tool-header"
    headerTitle="Transfer Enrollment and Trends"
    subtitle="View enrollment trend, student data, and retention/graduation rates for transfer students."
  ></tool-header>

  <transfer-enrollment-trends-content
    class="main-content"
  ></transfer-enrollment-trends-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'Transfer Enrollment and Trends'
      )
    "
  ></related-links>
</tool-drawer-container>
